export default "<div class=\"tab-pane fade\" [id]=\"tabContentLink\" role=\"tabpanel\">\r\n   <ng-content select=\"[tab-content]\"></ng-content>\r\n</div>\r\n";